"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.declarativeAgentTemplates = void 0;
const templateNames_1 = require("../templateNames");
exports.declarativeAgentTemplates = [
    {
        id: "declarative-agent-basic",
        name: templateNames_1.TemplateNames.DeclarativeAgentBasic,
        language: "common",
        description: "",
    },
    {
        id: "declarative-agent-basic-csharp",
        name: templateNames_1.TemplateNames.DeclarativeAgentBasic,
        language: "csharp",
        description: "",
    },
    {
        id: "declarative-agent-basic",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithExistingAction,
        language: "common",
        description: "",
    },
    {
        id: "declarative-agent-basic-csharp",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithExistingAction,
        language: "csharp",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-scratch-ts",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratch,
        language: "typescript",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-scratch-js",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratch,
        language: "javascript",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-scratch-csharp",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratch,
        language: "csharp",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-scratch-bearer-ts",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchBearer,
        language: "typescript",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-scratch-bearer-js",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchBearer,
        language: "javascript",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-scratch-bearer-csharp",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchBearer,
        language: "csharp",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-scratch-oauth-ts",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchOAuth,
        language: "typescript",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-scratch-oauth-js",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchOAuth,
        language: "javascript",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-scratch-oauth-csharp",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchOAuth,
        language: "csharp",
        description: "",
    },
    {
        id: "declarative-agent-typespec",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithTypeSpec,
        language: "common",
        description: "",
    },
    {
        id: "declarative-agent-with-graph-connector-ts",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithGraphConnector,
        language: "typescript",
        description: "",
    },
    {
        id: "declarative-agent-meta-os-new-project",
        name: templateNames_1.TemplateNames.DeclarativeAgentMetaOSNewProject,
        language: "common",
        description: "",
    },
    {
        id: "declarative-agent-meta-os-upgrade-project",
        name: templateNames_1.TemplateNames.DeclarativeAgentMetaOSUpgradeProject,
        language: "common",
        description: "",
    },
];
//# sourceMappingURL=da.js.map